module.exports = __webpack_public_path__ + "static/media/FanZone-Generic.890adced.jpg";